import { Platform, Pressable } from "react-native";
import { useTheme, YStack, Text } from "tamagui";
import { ArrowLeftRight } from '@tamagui/lucide-icons';
import { FloatingAction } from 'react-native-floating-action';

export function ModeratorFloatButtonComponent({ navigateToModeration }) {
  const theme = useTheme()
  return (
    <>
      {Platform.OS !== 'web' ? (
        <FloatingAction
          onPressMain={navigateToModeration}
          overlayColor={'transparent'}
          color={theme['homeFloatingButtonBg']?.val}
          buttonSize={76}
          floatingIcon={
            <YStack alignItems="center">
              <ArrowLeftRight color={'#FFF'} size={18} fontSize={12} />
              <Text
                style={{
                  fontSize: 11,
                  color: '#FFF',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                Move to moderator
              </Text>
            </YStack>
          }
        />
      ) : (
        <Pressable
          testID="kisan_tId_ModeratorButton"
          style={{
            position: 'absolute',
            bottom: 100,
            right: 20,
            width: 100,
            height: 100,
            borderRadius: 50,
            backgroundColor: theme['homeFloatingButtonBg']?.val,
            justifyContent: 'center',
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.8,
            shadowRadius: 2,
            elevation: 5,
            zIndex:999
          }}
          onPress={navigateToModeration}
        >
          <YStack alignItems="center">
            <ArrowLeftRight color={'#FFF'} size={18} fontSize={12} />
            <Text
              style={{
                fontSize:14,
                 color: '#FFF',
                 paddingLeft:20
              }}
            >
              Move to moderator
            </Text>
          </YStack>
        </Pressable>
      )}
    </>

  )
}